/*
 * NYORD: Beim Klick auf „In den Warenkorb“ fliegt das Produkt in einem flachen Bogen in seine Zeile der
 * Warenkorb-Leiste (snippets/nb-warenkorb); die Zeile leuchtet kurz golden auf (CSS in nb-warenkorb.css).
 * Geflogen wird das freigestellte Produkt (Shopify-Datei nyord-<handle>-freigestellt.png, beim Klick vorgeladen);
 * gibt es keins, ein rundes Vorschaubild mit Goldring statt des eckigen Kartenbilds.
 * Gilt für den Ein-Klick-Kauf (Startseite, Kollektionen, Zuletzt angesehen) und für Produktseiten.
 * Nur transform/opacity, etwa 0,7 s. Bei „Bewegung reduzieren“ nur das Aufleuchten.
 */
(function () {
  if (window.nbFlugBereit) return;
  window.nbFlugBereit = true;
  var weniger = window.matchMedia('(prefers-reduced-motion: reduce)');
  var start = null;

  function quelle(knopf) {
    var karte = knopf.closest('.nb-raster__eintrag, .nb-zuletzt__karte, .nb-tabs__raster > li, .card-wrapper');
    var bild = karte && karte.querySelector('.card__media img, .media img');
    var link = karte && karte.querySelector('a[href*="/products/"]');
    var pfad = link ? link.getAttribute('href') : window.location.pathname;
    if (!bild) bild = document.querySelector('.product__media-item.is-active img, .product__media img');
    var treffer = pfad.match(/\/products\/([^/?#]+)/);
    return { bild: bild, handle: treffer && decodeURIComponent(treffer[1]) };
  }

  // Freigestelltes Produkt vorladen (URL liefert snippets/nb-freisteller über data-freisteller am Ein-Klick-Kauf);
  // ist es rechtzeitig da, fliegt nur das Produkt
  function freisteller(knopf) {
    var kauf = knopf.closest('nb-schnellkauf');
    var url = kauf && kauf.dataset.freisteller;
    if (!url) return null;
    var bild = new Image();
    bild.decoding = 'async';
    bild.src = url;
    return bild;
  }

  // Klick merken (Capture, also vor Dawns product-form): Variante und Bild
  document.addEventListener(
    'click',
    function (e) {
      var knopf = e.target.closest('button[name="add"], .product-form__submit');
      if (!knopf || knopf.disabled) return;
      var formular = knopf.form || knopf.closest('form');
      var eingabe = formular && formular.querySelector('input[name="id"]');
      var q = quelle(knopf);
      start = { variante: eingabe && eingabe.value, bild: q.bild, frei: freisteller(knopf), zeit: performance.now() };
    },
    true
  );

  function zielzeile(leiste, variante) {
    var zeilen = leiste.querySelectorAll('.cart-item');
    for (var i = 0; i < zeilen.length; i++) {
      var link = zeilen[i].querySelector('a[href*="variant="]');
      if (link && variante && link.getAttribute('href').indexOf('variant=' + variante) !== -1) return zeilen[i];
    }
    return zeilen[0];
  }

  function leuchten(zeile) {
    zeile.classList.remove('nb-wk-neu');
    void zeile.offsetWidth;
    zeile.classList.add('nb-wk-neu');
  }

  function landen(leiste, s) {
    var zeile = zielzeile(leiste, s.variante);
    if (!zeile) return;
    leuchten(zeile);
    var ziel = zeile.querySelector('.cart-item__image');
    if (weniger.matches || !s.bild || !ziel || !s.bild.complete) return;
    var a = s.bild.getBoundingClientRect();
    var b = ziel.getBoundingClientRect();
    if (!a.width || !b.width) return;
    // Ohne vorgeladenen Freisteller (z. B. Produktseite): das freigestellte Zeilenbild der Leiste nehmen
    if (!(s.frei && s.frei.complete && s.frei.naturalWidth > 0) && ziel.classList.contains('cart-item__image--frei') && ziel.complete) {
      s.frei = ziel.cloneNode();
    }
    var frei = s.frei && s.frei.complete && s.frei.naturalWidth > 0;
    var flieger = frei ? s.frei : s.bild.cloneNode();
    flieger.removeAttribute('loading');
    flieger.removeAttribute('srcset');
    flieger.removeAttribute('sizes');
    if (!frei) flieger.src = s.bild.currentSrc || s.bild.src;
    flieger.setAttribute('aria-hidden', 'true');
    flieger.alt = '';
    flieger.className = 'nb-wk-flieger' + (frei ? ' nb-wk-flieger--frei' : ' nb-wk-flieger--rund');
    // Rundes Vorschaubild: auf die kleinere Seite zuschneiden, mittig über dem Kartenbild
    if (!frei) {
      var seite = Math.min(a.width, a.height) * 0.72;
      a = { left: a.left + (a.width - seite) / 2, top: a.top + (a.height - seite) / 2, width: seite, height: seite };
    }
    Object.assign(flieger.style, {
      left: a.left + 'px',
      top: a.top + 'px',
      width: a.width + 'px',
      height: a.height + 'px',
    });
    document.body.appendChild(flieger);
    ziel.style.opacity = '0';
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var skala = b.width / a.width;
    var flug = flieger.animate(
      [
        { transform: 'translate(0, 0) scale(1) rotate(0deg)' },
        {
          transform:
            'translate(' + dx * 0.55 + 'px, ' + (dy * 0.55 - 80) + 'px) scale(' + (1 + (skala - 1) * 0.6) + ') rotate(-8deg)',
          offset: 0.55,
        },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + skala + ') rotate(0deg)' },
      ],
      { duration: 780, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
    );
    var fertig = function () {
      ziel.style.opacity = '';
      flieger.remove();
    };
    flug.onfinish = fertig;
    flug.oncancel = fertig;
  }

  function beobachten() {
    var leiste = document.querySelector('cart-drawer');
    if (!leiste) return;
    var geplant = false;
    // Neu gerendert (childList) und offen (Klasse active): erst nach dem Einschieben (200 ms) messen
    new MutationObserver(function () {
      if (!start || geplant || performance.now() - start.zeit > 8000) return;
      if (!leiste.classList.contains('active') || !leiste.querySelector('.cart-item')) return;
      var s = start;
      start = null;
      geplant = true;
      setTimeout(function () {
        geplant = false;
        landen(leiste, s);
      }, 240);
    }).observe(leiste, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', beobachten);
  else beobachten();
})();
